import React from "react";
import { Form } from "react-bootstrap";
import ConfirmationModal, { useConfirmationModal } from "common/ui/ConfirmationModal";
import { AgGridReact } from "@ag-grid-community/react";
import defaultGridOptions from "common/agGrid/defaultGridOptions";
import columnBuilder from "common/agGrid/columnBuilder";
import RenderParameters from "common/agGrid/renderParameters";
import { CustomFieldGroup } from "domain/customField";

export interface ManageCustomFieldGroupsProps {
    customFieldGroups: CustomFieldGroup[];

    onAdd(): void;
    onUpdate(customFieldGroup: CustomFieldGroup): Promise<any>;
    onRemove(customFieldGroup: CustomFieldGroup): Promise<any>;
}

const ManageCustomFieldGroups: React.FC<ManageCustomFieldGroupsProps> = props => {
    const confirmModal = useConfirmationModal();

    function getColumns() {
        return [
            columnBuilder.build("#", null,
                {
                    valueGetter: (params: any) => `Custom Field Group #${params.data.sortOrder}`,
                    minWidth: 150,
                    maxWidth: 150,
                }),
            columnBuilder.build("Name", "name",
                {
                    cellRenderer: function (params: RenderParameters<CustomFieldGroup, string>) {
                        return <Form.Control
                            defaultValue={params.node.data.name}
                            placeholder={"Name"}
                            required
                            onBlur={(ev: React.ChangeEvent<HTMLInputElement>) => onUpdate({ ...params.node.data, name: ev.target.value })} />;
                    },
                    minWidth: 200,
                }),
            columnBuilder.build("", null,
                {
                    cellRenderer: function (params: RenderParameters<CustomFieldGroup>) {
                        return <button className="link-button" onClick={() => onRemove(params.node.data)}>
                            <i className="material-icons">delete</i>
                        </button>;
                    },
                    maxWidth: 50,
                }),
        ];
    }

    function onUpdate(customFieldGroup: CustomFieldGroup): void {
        props.onUpdate(customFieldGroup);
    }

    function onRemove(customFieldGroup: CustomFieldGroup): void {
        confirmModal.show(
            `Remove Custom Field Group - ${customFieldGroup.name}`,
            <>Do you really want to remove this custom field group - {customFieldGroup.name}</>,
            () => props.onRemove(customFieldGroup),
            undefined,
            false,
        );
    }

    return <>
        <div className="ag-theme-alpine">
            <div className="row table-header-row ml-0 mr-0">
                <div className="col">
                    <div className="page-sub-header">Custom Field Groups</div>
                </div>
                <div className="col action-bar">
                    <button className="btn btn-link ml-auto" onClick={props.onAdd}>
                        <i className="material-icons">add_circle_outline</i>
                        Add Custom Field Group
                    </button>
                </div>
            </div>

            <AgGridReact
                {...defaultGridOptions}
                columnDefs={getColumns()}
                rowHeight={32}
                rowData={props.customFieldGroups ?? []}
                getRowId={params => `customFieldGroups-${params.data.id}-${params.data.sortOrder}`}
                domLayout="autoHeight"
                onGridReady={params => params.api.sizeColumnsToFit()}
            />
        </div>

        <ConfirmationModal modalState={confirmModal.state} />
    </>;
};

export default ManageCustomFieldGroups;